import { Injectable } from '@angular/core';
import { ICompany } from '@common/interfaces/company';
import { Topics } from '@common/interfaces/topics';
import { AuthQuery } from '@ep-om/project/auth/auth.query';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { CompanyQuery } from './company.query';
import { CompanyStore } from './company.store';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends CrudService<ICompany, CompanyStore, CompanyQuery> {

  constructor(
    protected store: CompanyStore,
    public query: CompanyQuery,
    protected authQuery: AuthQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.COMPANIES,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
